import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import 'react-select/dist/react-select.css';
import Header from '../../components/Header';
import classes from './AppLayout.scss';
// import '../../styles/core.scss';

import SideBar from '../../components/SideBar/SideBar';
import ActionButton from '../../components/ActionButton';

import OnboardingDialog from '../../components/OnboardingDialog/OnboardingDialog';
import TaskDialog from '../../components/TaskDialog/TaskDialog';
import FormActivity from '../../components/FormActivity/FormActivity';
import FormCompany from '../../components/FormCompany/FormCompany';
import FormProject from '../../components/FormProject/FormProject';
import FormStaff from '../../components/FormStaff/FormStaff';
import FormPerson from '../../components/FormPerson/FormPerson';
import ServiceKeyFormContainer from '../../containers/ServiceKeyFormContainer';
import NumberRangeFormContainer from '../../containers/NumberRangeFormContainer';
import FeedbackProvider from '../../components/FeedbackProvider/FeedbackProvider';
import ServerSync from '../../components/ServerSync/ServerSync';

const mapActionCreators = {};

const mapStateToProps = state => ({
  compactMode: state.options.compactMode,
  activityOpen: state.activity.formOpen,
  companyOpen: state.company.formOpen,
  projectOpen: state.project.formOpen,
  staffOpen: state.staff.formOpen,
  personOpen: state.person.formOpen,
});

const CoreLayout = ({
  children,
  router,
  activityOpen,
  companyOpen,
  projectOpen,
  staffOpen,
  personOpen,
  compactMode,
}) => (
  <div
    className={`${classes.slidingContainer} ${
      compactMode ? 'compactMode' : ''
    }`}
  >
    <div className={classes.container}>
      <Header />
      <div className={classes.content}>
        <div className={`mainContainer ${classes.mainContainer}`} id="scroller">
          {children}
          <div className={`${classes.spacer}`} />
        </div>
        <SideBar />
      </div>
    </div>

    <ActionButton />

    <FormActivity />
    <FormCompany />
    <FormProject />
    <FormStaff />
    <FormPerson />

    <ServiceKeyFormContainer push={router.push} />
    <NumberRangeFormContainer push={router.push} />

    <TaskDialog />
    <OnboardingDialog />

    <FeedbackProvider />

    <ServerSync />
  </div>
);

CoreLayout.propTypes = {
  children: PropTypes.element.isRequired,
  router: PropTypes.object.isRequired,
  compactMode: PropTypes.bool.isRequired,
  activityOpen: PropTypes.bool.isRequired,
  companyOpen: PropTypes.bool.isRequired,
  projectOpen: PropTypes.bool.isRequired,
  staffOpen: PropTypes.bool.isRequired,
  personOpen: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapActionCreators)(CoreLayout);



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/AppLayout.js